import React from 'react';
import Body from './body';
import { MenuSide } from '@polichat/flamboyant';
import { generateWhatsAppWebLink } from 'src/utils/whatsappLink';

export default (props) => {
  return (
    <div className="bodyContentContainer">
      {/* {<MenuSide
        iconOne="poli-icon pi-whatsapp-fill"
        textOne="  Suporte"
        textTooOne="Entre em contato com o suporte do Polichat"
        onClickOne={() => {
          window.open(generateWhatsAppWebLink('spa.common.whatsapp.wantToKnowCRM', true));
        }}
        iconTwo="poli-icon pi-talks-fill"
        textTwo="  Feedback"
        textTooTwo="Envie seu feedback sobre nossa plataforma"
        onClickTwo={() => {
          window.open('https://forms.gle/BuWnxve6UsiZUz2QA');
        }}
      /> } */}
      <Body />
    </div>
  );
};
